module.exports = __webpack_public_path__ + "static/media/BABYCAKE.085e4585.svg";